export const groupByValues = {
  products: 'product',
  variants: 'variant',
  categories: 'product_type',
  types: 'category',
  collections: 'collection',
}

export const displayValues = {
  daily: 'daily',
  weekly: 'weekly',
  monthly: 'monthly',
  quarterly: 'quarterly',
}

export const displayThresholds = {
  weeklyMin: 35,
  monthlyMin: 64,
  quarterlyMin: 731,
}

export const metricsDimensionTabs = {
  product: 'product',
  order: 'order',
}
